import React from 'react'

import { useReferralsContext } from '@user/components/Referrals/context'
import {
  TidalCustomerContent,
  TidalEmployeeContent,
  TidalOtherContent,
} from './'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'

export function TidalContent(props: ReferralFormProps) {
  const [{ referralType }] = useReferralsContext()

  switch (referralType) {
    case 'Customer':
      return <TidalCustomerContent {...props} />
    case 'Employee':
      return <TidalEmployeeContent {...props} />
    case 'Other':
      return <TidalOtherContent {...props} />
    default:
      return null
  }
}
